import React from 'react'
import './index.less'

export default function HomeHeader() {
  return (
    <div className="light-header">
      <span className="header-title">
        勇电业务战略平台
      </span>
    </div>
  )
}